export default "__VITE_ASSET__77d62b34__"